export default{
    selectType:"Please select category",
    options:{
        "changePassword":'Change password'
    },
    changPasswordTip:'If you do not have a password, the initial password is 000000, you can set a new password'
}